<div class="container">
    <div class="search-wrapper">
      <button class="btn btn-dark-blue" [routerLink]="options.route" [fragment]="options.fragment">{{options.title}}</button>
    </div>
  </div>
  